module.exports = __webpack_public_path__ + "static/media/icon-historique-medical.f3234833.svg";